<mat-button-toggle-group>
  <mat-button-toggle
    class="toolbar-button"
    [matMenuTriggerFor]="feedbackList"
    #trigger="matMenuTrigger"
    (click)="toggleFeedbackList()"
    [checked]="shouldOpenFeedbackPopover$ | async"
    [disabled]="isDisabled$ | async"
    (menuOpened)="onPopoverOpen()"
    (menuClosed)="onPopoverClose()"
  >
    <mat-icon fontIcon="flag" class="material-symbols-outlined"></mat-icon>
    <fa-icon
      [icon]="faCircle"
      transform="shrink-8 up-8 left-6"
      *ngIf="(isDisabled$ | async) === false"
    ></fa-icon>
  </mat-button-toggle>
</mat-button-toggle-group>

<mat-menu #feedbackList="matMenu" xPosition="before" [hasBackdrop]="false">
  <ng-template matMenuContent>
    <div (click)="$event.stopPropagation()" *h3Injector="injector$ | async">
      <h3-cv-feedback-panel></h3-cv-feedback-panel>
    </div>
  </ng-template>
</mat-menu>
